import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BarChart3,
  Bell,
  Building2,
  CreditCard,
  FileText,
  LayoutDashboard,
  LogOut,
  Sparkles,
  Wallet,
} from 'lucide-react';

import './ControlCenterDashboard.css';

const ControlCenterDashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('vakra_control_admin_token');
    localStorage.removeItem('vakra_control_admin');

    sessionStorage.removeItem('vakra_control_admin_token');
    sessionStorage.removeItem('vakra_control_admin');

    navigate('/control-center/login', {
      replace: true,
    });
  };

  return (
    <div className="vccd-page">
      <aside className="vccd-sidebar">
        <div className="vccd-brand">
          <div className="vccd-logo">V</div>

          <div>
            <strong>VAKRA</strong>
            <span>CONTROL CENTER</span>
          </div>
        </div>

        <nav className="vccd-nav">
          <button
            type="button"
            className="active"
            onClick={() =>
              navigate('/control-center/dashboard')
            }
          >
            <LayoutDashboard size={18} />
            Dashboard
          </button>

          <button
            type="button"
            onClick={() =>
              navigate('/control-center/vendors')
            }
          >
            <Building2 size={18} />
            Vendors
          </button>

          <button type="button">
            <CreditCard size={18} />
            Subscriptions
          </button>

          <button type="button">
            <Wallet size={18} />
            Payments
          </button>

          <button type="button">
            <FileText size={18} />
            Agreements
          </button>

          <button type="button">
            <Sparkles size={18} />
            Smart Offer Digest
          </button>

          <button type="button">
            <BarChart3 size={18} />
            Analytics
          </button>
        </nav>

        <button
          type="button"
          className="vccd-logout"
          onClick={handleLogout}
        >
          <LogOut size={18} />
          Logout
        </button>
      </aside>

      <main className="vccd-main">
        <header className="vccd-header">
          <div>
            <span>VAKRA CONTROL CENTER</span>
            <h1>Dashboard</h1>
          </div>

          <button type="button" className="vccd-bell">
            <Bell size={20} />
          </button>
        </header>

        <section className="vccd-content">
          <div className="vccd-welcome">
            <h2>Welcome to VAKRA Control Center</h2>

            <p>
              Vendors, subscriptions, payments, agreements aur
              Smart Offer Digest yahan se manage honge.
            </p>
          </div>

          <div className="vccd-stats">
            <article>
              <Building2 size={22} />
              <span>Total Vendors</span>
              <strong>0</strong>
            </article>

            <article>
              <CreditCard size={22} />
              <span>Active Subscriptions</span>
              <strong>0</strong>
            </article>

            <article>
              <Wallet size={22} />
              <span>Monthly Collection</span>
              <strong>₹0</strong>
            </article>

            <article>
              <Sparkles size={22} />
              <span>Smart Campaigns</span>
              <strong>0</strong>
            </article>
          </div>

          <div className="vccd-panels">
            <section>
              <h3>Recent Activity</h3>
              <p>
                Vendor, payment aur subscription activity yahan
                show hogi.
              </p>
            </section>

            <section>
              <h3>Quick Actions</h3>

              <button
                type="button"
                onClick={() =>
                  navigate('/control-center/vendors')
                }
              >
                Manage Vendors
              </button>
            </section>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ControlCenterDashboard;
